import { Injectable, inject } from '@angular/core';
import { ReactiveContainer } from '../../../../core/containers/reactive-container';
import { ApolloService } from '../../../../core/services/apollo.service';
import { ToastService } from '../../../../core/services/toast/toast.service';
import { NotificationListStore } from './notification-list.store';
import * as fromGraphQl from './graphql';

/** Zaehler alle 30s — unteres Ende der Vorgabe 30-60s, unabhaengig davon, ob das Popover offen ist. */
const UNREAD_COUNT_POLL_INTERVAL_MS = 30000;

/**
 * Seitengroesse des Popovers. Seit der Nacharbeit vom 19.08.2026 scrollt das Popover endlos statt
 * einen Auszug von fuenf Zeilen zu zeigen (Entscheidung 10 ueberstimmt) — fuenf waeren jetzt fuenf
 * Netzabrufe fuer einen Bildschirm. 20 ist der Default des Servers.
 */
const POPOVER_PAGE_SIZE = 20;

/**
 * Sitzungsweiter Teil des In-App-Notification-Streams (#736).
 *
 * Hier liegt nur, was tatsaechlich sitzungsweit ist: der Ungelesen-Zaehler mit seinem Poll und die
 * Store-Instanz des Popovers. Letztere muss hier liegen, weil `p-overlayPanel` seinen Inhalt an
 * `*ngIf="render"` haengt und `render` bei jedem Schliessen zuruecksetzt —
 * `NotificationCenterComponent` wird pro Oeffnen NEU instanziiert und kann keinen Zustand halten.
 *
 * Die Seite /notifications holt sich ueber `createListStore()` eine eigene Instanz
 * (Entscheidung 12).
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly apolloService = inject(ApolloService);
  private readonly toastService = inject(ToastService);

  private readonly countContainer = new ReactiveContainer<fromGraphQl.UnreadCountResponse>(
    fromGraphQl.UNREAD_COUNT_QUERY,
    { pollInterval: UNREAD_COUNT_POLL_INTERVAL_MS, stopPollingOnSuccess: false, useGlobalLoading: false }
  );

  readonly unreadCount = this.countContainer.selectWithDefault(
    (data) => data.getMyUnreadNotificationsCount,
    0
  );

  /** Die Liste des Popovers. Ueberlebt das Zerstoeren der Center-Komponente. */
  readonly popoverList = this.createListStore(POPOVER_PAGE_SIZE);

  private hasStartedCountPolling = false;

  /** Einmal pro Session aus LayoutComponent.ngOnInit, analog PreferredLanguageSyncService.syncOnce(). */
  startCountPolling(): void {
    if (this.hasStartedCountPolling) {
      return;
    }
    this.hasStartedCountPolling = true;
    this.countContainer.execute({});
  }

  /** Eine eigene Listeninstanz, z. B. fuer die Seite /notifications. */
  createListStore(pageSize: number): NotificationListStore {
    return new NotificationListStore(
      this.apolloService,
      this.toastService,
      pageSize,
      () => this.refetchCount()
    );
  }

  refetchCount(): void {
    this.countContainer.reload();
  }
}
